import { createContext } from 'react';
import { IMenuChatsContext } from './types';

const MenuChatsContext = createContext<IMenuChatsContext>({} as IMenuChatsContext);

export default MenuChatsContext;
